/**
 * The next line imports all components and standard configuration from GeoGirafe.
 * You will be able to use all the standard components just by adding them in your html file like this for example:
 *
 * <girafe-about></girafe-about>
 *
 * If you prefer to be more specific a have more control on which component you want to integrate in your application
 * You can remove this line, integrate them individually, and define the name of the custom element
 * For exemple:
 *
 * import AboutComponent from './components/about/component';
 * customElements.define('girafe-about', AboutComponent);
 *
 * You will also have to do some others things manually, like:
 * - initialize the managers
 * - define the configuration of tippy, proj4, and cesium
 * - extend the standard Document and Window interfaces
 *
 * You can look here for an example: https://gitlab.com/geogirafe/gg-viewer/-/blob/main/src/main.ts
 *
 **/
 
import { redirectTo, initializeGeoGirafeCustomStyles, SplashScreen } from '@geogirafe/lib-geoportal/tools';
import { GeoGirafeApp } from '@geogirafe/lib-geoportal/core';

/**
 * MyExtendedComponent is an example of how to extend an existing component in GeoGirafe.
 */
import MyExtendedComponent from './components/my-extended-component/component';

import CopyrightComponent from './components/copyright/component';

// Redirect to mobile interface if we are on mobile
if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('Android')) {
    const redirectUrl = document.querySelector('meta[name=redirect-url]')?.getAttribute('content');
    if (redirectUrl) {
        redirectTo(redirectUrl);
    }
}

// Display the splash-screen
const splash = new SplashScreen();
splash.begin();

initializeGeoGirafeCustomStyles();

// Create the new GeoGirafe Application
const girafeApp = new GeoGirafeApp();

// Wait until the application is ready
girafeApp.isReady().then(() => {

    // Define custom components
    customElements.define('my-extended-component', MyExtendedComponent);
    customElements.define('girafe-copyright', CopyrightComponent);

    // Remove the splash-screen
    splash.end();
    girafeApp.context.onBoardingManager.start();
});

